'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import Image from 'next/image';
import Box from '@classify/react-core-components/Box';
import Button from '@classify/react-core-components/Button';
import { translate } from '@openclassrooms/translations';
import HeroImage from './HeroImage';
import VimeoPlayer from './VimeoPlayer';
import VideoPlayerSvg from '../images/video-player.svg';
const THUMBNAIL_SIZES = {
  default: 188,
  sm: 286,
  md: 250,
  lg: 388
};
type Props = {
  title: string;
  fallbackImgUrl: string;
  videoId?: number;
};
export default function HeroVideo(t0) {
  const $ = _c(13);
  const {
    title,
    fallbackImgUrl,
    videoId
  } = t0;
  const [isVideoOpened, setIsVideoOpened] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      position: "relative",
      width: {
        xs: THUMBNAIL_SIZES.default,
        sm: THUMBNAIL_SIZES.sm,
        md: THUMBNAIL_SIZES.md,
        lg: THUMBNAIL_SIZES.lg
      },
      aspectRatio: "1/1"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== fallbackImgUrl) {
    t2 = <HeroImage src={fallbackImgUrl} />;
    $[1] = fallbackImgUrl;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Button sx={{
      border: "none",
      borderRadius: "50%",
      outlineOffset: -2,
      backgroundColor: "transparent !important",
      position: "absolute",
      top: 0,
      height: "100%",
      width: "100%",
      "& svg": {
        height: 56,
        width: 56
      },
      cursor: "pointer"
    }} onClick={() => setIsVideoOpened(true)} aria-label={translate("global.word.play_video")}><Image src={VideoPlayerSvg} width={56} height={56} alt="" /></Button>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2) {
    t4 = <Box sx={t1} data-testid="hero-video">{t2}{t3}</Box>;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== isVideoOpened || $[7] !== title || $[8] !== videoId) {
    t5 = videoId && <VimeoPlayer id={videoId} isOpened={isVideoOpened} onClose={() => setIsVideoOpened(false)} title={title} />;
    $[6] = isVideoOpened;
    $[7] = title;
    $[8] = videoId;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <>{t4}{t5}</>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}